import CurrentUser from './currentUser/reducer'
import LanguageSwitcher from './languageSwitcher/reducer';

export default {
    LanguageSwitcher,
    CurrentUser
};
